import { Routes, Route } from "react-router-dom";

import Navigation from "./routes/navigation/navigation.component";
import Home from "./routes/home/home.component";
import About from "./routes/about/about.component";
import Property from "./routes/property/property.component";
import PropertyDetail from "./components/property-detail/property-detail.component";
import Team from "./routes/team/team.component";
import Contact from "./routes/contact/contact.component";
import Profile from "./routes/profile/profile.component";
import Inquiry from "./routes/inquiry/inquiry.component";
import ResetPassword from "./routes/reset-password/reset-password";
import PageNotFound from "./routes/404/404";

import "./App.scss";
import PrivateRoute from "./components/PrivateRoute";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigation />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="property" element={<Property />} />
        <Route path="property/:slug" element={<PropertyDetail />} />
        <Route path="team" element={<Team />} />
        <Route path="contact" element={<Contact />} />
        <Route
          path="profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
        <Route
          path="my-inquiry"
          element={
            <PrivateRoute>
              <Inquiry />
            </PrivateRoute>
          }
        />
        <Route path="reset-password/:token" element={<ResetPassword />} />
        <Route path="*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
}

export default App;
